/* vuetifyの読み込み */
import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
  iconfont: ["md", "fa"],
  theme: {
    "primary": "#ffde59",
    "secondary": "#ff0077",
    "accent": "#ff4081",
    "error": "#ff5722",
    "info": "#00e5ff",
    "success": "#b2ff59",
    "warning": "#ffeb3b"
  }
});
